var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-outfits"},[(_vm.capsuleOutfits.length === 0)?_c('div',[_c('OutfitsEmptyState')],1):_c('div',{staticClass:"outfits-grid"},_vm._l((_vm.capsuleOutfits),function(outfit){return _c('outfit',{key:outfit.id,attrs:{"outfit":outfit}})}),1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59617988","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/showCapsule/tabs/OutfitsTab.vue
// module id = Dlyq
// module chunks = 0